import Vision from './Vision';
import Mission from './Mission';

export default function Motivation() {
    return (
        <div>
            <Mission />
            <Vision />
        </div>
    );
}